import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
  { n: "01", title: "Discovery Call", body: "Fifteen focused minutes mapping your business, your gaps, and your goals. No pitch — just clarity." },
  { n: "02", title: "Strategic Alignment", body: "A tailored marketing roadmap aligned to your revenue targets and timeline." },
  { n: "03", title: "Embedded Execution", body: "Working alongside your team — leading, executing, and iterating until results show up." },
];

const Process = () => (
  <section id="process" data-testid="process-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-line">
    <div className="mx-auto max-w-[100rem] grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-6">
        <SectionHead
          index="04"
          label="How It Works"
          title={<>A structured process. <em className="text-taupe">No onboarding drag.</em></>}
        />
        <div>
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div data-testid={`process-step-${s.n}`} className="flex gap-8 border-t border-line py-8 md:py-10">
                <span className="font-serif italic text-taupe text-2xl md:text-3xl shrink-0 w-14">{s.n}.</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-normal tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base font-light text-ash leading-relaxed max-w-md">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.2}>
            <p className="mt-6 font-serif italic text-xl text-taupe border-t border-line pt-8">
              Most clients see measurable momentum within the first 30 days.
            </p>
          </Reveal>
        </div>
      </div>
      <Reveal className="lg:col-span-6" delay={0.15}>
        <div className="relative lg:sticky lg:top-28 overflow-hidden aspect-[4/5] lg:aspect-auto lg:h-[calc(100vh-10rem)]">
          <img
            src="/images/aspen-campaign.webp"
            alt="Makkar Growth Partners brand campaign — Lead boldly. Grow powerfully."
            data-testid="process-image"
            className="h-full w-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-paper/80 backdrop-blur-md border-t border-line px-6 py-4">
            <p className="text-[10px] uppercase tracking-[0.25em] text-ash">
              From the brand — "Lead Boldly. Grow Powerfully." campaign
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Process;
